import React from "react";
import {HourLogTable} from "./HourLogTable";


const ProjectSearchHourLogTab = ({
                                  loading,
                                  hourLog
                                }) => {
  return (
    <>
      <HourLogTable
        hourLog={hourLog}
        loading={loading}
        projectSearch={true}
        isModal={false}
      />
    </>
  );
};

export {ProjectSearchHourLogTab};